import { Component } from '@angular/core'
import { BreadcrumbMeta, CmsService, PageMetaService, TranslationService } from '@spartacus/core'
import { CurrentProductService } from '@spartacus/storefront'
import { combineLatest, Observable } from 'rxjs'
import { distinctUntilChanged, map } from 'rxjs/operators'
import {
  EbProduct,
  EbProductTypeEnum
} from '../../features/product/interfaces/eb-product.interface'
import { EbLanguageService } from '../../features/site-context/services/eb-language.service'

@Component({
    selector: 'eb-breadcrumb',
    templateUrl: './eb-breadcrumb.component.html',
    styleUrls: ['./eb-breadcrumb.component.scss'],
    standalone: false
})
export class EbBreadcrumbComponent {
  constructor(
    public pageMetaService: PageMetaService,
    protected languageService: EbLanguageService,
    protected currentProductService: CurrentProductService,
    protected translation: TranslationService,
    protected cms: CmsService
  ) {}

  get pageMeta$(): Observable<{
    title: string
    breadcrumbs: BreadcrumbMeta[]
    product?: EbProduct
  }> {
    return combineLatest([
      this.pageMetaService.getMeta(),
      this.translation.translate('common.home'),
      this.languageService.getActive(),
      this.cms.getCurrentPage(),
      this.currentProductService.getProduct()
    ]).pipe(
      distinctUntilChanged(
        (oldValue, newValue) => JSON.stringify(oldValue[3]) !== JSON.stringify(newValue[3])
      ),
      map(([meta, textHome, activeLanguage, page, product]) => {
        if (meta.breadcrumbs) {
          const ebProduct = product as EbProduct
          const defaultCrumb = { label: textHome, link: '/' }
          if (!meta.breadcrumbs.some(crumb => crumb.label === textHome)) {
            meta.breadcrumbs.unshift(defaultCrumb)
          }
          if (page?.pageId === 'ebWebshopHomepage') {
            meta.breadcrumbs = []
          }
          if (page?.pageId === 'ebProductDetails') {
            let productCrumb
            if (this.isVariant(product)) {
              productCrumb = {
                link: this.getParentUrl(product),
                label: ebProduct.parentProductName
              }
            } else {
              productCrumb = {
                link: '',
                label: ebProduct.name
              }
            }
            const index = this.getIndexForProductBreadcrumb(meta.breadcrumbs, productCrumb)
            index >= 0
              ? (meta.breadcrumbs[index] = productCrumb)
              : meta.breadcrumbs.push(productCrumb)
          }
          return {
            title: meta.heading || meta.title,
            breadcrumbs: meta.breadcrumbs,
            product
          }
        }
      })
    )
  }

  private getParentUrl(product): string {
    return `/${product.parentProductFullPath}/p/${product.parentProductId}`
  }

  private isVariant(product): boolean {
    return product?.ebProductType === EbProductTypeEnum.VARIANT
  }

  private getIndexForProductBreadcrumb(
    breadcrumbs: BreadcrumbMeta[],
    productCrumb: BreadcrumbMeta
  ): number {
    return breadcrumbs.findIndex(el => el.label === productCrumb.label)
  }
}
